import React, { useState, useContext } from 'react'
import styles from './Prefecture.module.css'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { BackButton } from '../../../Common/CtaButton/BackButton'
import { StepContext } from '../../../Context/StepContext'
import { useAbTestGtm } from '../../../utils/abTest'

export const Prefecture = ({ prefectures }) => {
    const { handleNext, handlePrev, updateFormData, formData } = useContext(StepContext)
    const [isOpen, setIsOpen] = useState(false)
    const [displayFormData, setDisplayFormData] = useState('')
    const handleSelectClick = () => {
        setIsOpen(!isOpen)
    }

    const handleOptionSelect = (value, displayValue) => {
        updateFormData('prefecture', value)
        setDisplayFormData(displayValue)
        setIsOpen(false)
    }

    const handleNextClick = () => {
        if (formData.prefecture) {
            handleNext()
        }
    }

    const { dataViewLabel, dataClickLabel } = useAbTestGtm()

    return (
        <div className={styles.wrapper}>
            <div className={styles.title}>
                <BackButton dataClickLabel={dataClickLabel('EF_StepForm_Step3-お住まい-戻る')} onClick={handlePrev} />
                <h1
                    data-view-label={dataViewLabel('EF_StepForm_Step3-お住まい')}
                    className={styles.titleText}
                >
                    Q.現在のお住まいは？
                </h1>
            </div>

            <div className={styles.inputGroup}>
                <div className={styles.labelWrapper}>
                    <label className={styles.label}>都道府県</label>
                    <span className={styles.required}>必須</span>
                </div>

                <div className={styles.selectWrapper}>
                    <div
                        className={`${styles.customSelect} ${formData.prefecture ? styles.selected : ''}`}
                        onClick={handleSelectClick}
                    >
                        <span>{displayFormData || '都道府県を選んでください'}</span>
                        <div className={styles.selectArrow}>
                            <img
                                src='/entry_form_slide_app/common/selectArrow.png'
                                alt='選択矢印'
                            />
                        </div>
                    </div>
                    {isOpen && (
                        <div className={styles.optionsContainer}>
                            {prefectures.map((prefecture, index) => (
                                <div
                                    key={index}
                                    className={styles.optionItem}
                                    onClick={() => handleOptionSelect(prefecture[1], prefecture[0])}
                                >
                                    {prefecture[0]}
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>

            <NextButton
                disabled={!formData.prefecture}
                dataClickLabel={dataClickLabel('EF_StepForm_Step3-お住まい-次へ')}
                onClick={handleNextClick}
            />
        </div>
    )
}
